import lowerCase from 'lodash/lowerCase';
import PropTypes from 'prop-types';
import { memo, useCallback, useContext } from 'react';

import { AnalyticsJobFormCtaText, AnalyticsJobFormSection } from 'lib/analytics/constants';
import { JobFormControllerContext } from 'lib/oneflare-job-form/utils/context';

import {
  HeroStyled,
  HeroIntroStyled,
  HeroTitleStyled,
  HeroIntroTextStyled,
  GetFreeQuotesButtonStyled,
  HeroParentCategoryStyled,
  HeroImageStyled,
  HeroIntroWrapperStyled
} from './styled/SimpleHero';

const propTypes = {
  bgImg: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  testId: PropTypes.string,
  introText: PropTypes.string.isRequired,
  jobFormCategoryId: PropTypes.number,
  parentCategorySlug: PropTypes.string,
  title: PropTypes.string.isRequired,
  jobFormInitiatedPageName: PropTypes.string
};

const SimpleHero = ({
  className = '',
  children = null,
  title,
  introText,
  bgImg,
  jobFormCategoryId = null,
  parentCategorySlug = '',
  testId,
  jobFormInitiatedPageName
}) => {
  const { controller } = useContext(JobFormControllerContext);
  const handleJobFormLaunch = useCallback(async () => {
    await controller?.open({
      categoryId: jobFormCategoryId,
      page: jobFormInitiatedPageName,
      section: AnalyticsJobFormSection.HeroBanner,
      ctaText: AnalyticsJobFormCtaText.GetFreeQuotes
    });
  }, [controller, jobFormCategoryId, jobFormInitiatedPageName]);

  return (
    <HeroStyled data-testid={testId} className={className}>
      <HeroImageStyled
        alt="Hero image"
        src={bgImg}
        fill
        quality={50}
        priority
        sizes="100vw"
        style={{ objectFit: 'cover' }}
      />
      <HeroIntroWrapperStyled>
        <HeroIntroStyled>
          {parentCategorySlug && (
            <HeroParentCategoryStyled
              href={`/inspiration/${parentCategorySlug}`}
            >
              {lowerCase(parentCategorySlug)}
            </HeroParentCategoryStyled>
          )}
          <HeroTitleStyled>{title}</HeroTitleStyled>
          <HeroIntroTextStyled>{introText}</HeroIntroTextStyled>
          {children || (
            <GetFreeQuotesButtonStyled
              kind="primary"
              label="Get free quotes"
              onClick={handleJobFormLaunch}
              data-cy="get-quotes"
            />
          )}
        </HeroIntroStyled>
      </HeroIntroWrapperStyled>
    </HeroStyled>
  );
};

SimpleHero.propTypes = propTypes;

export default memo(SimpleHero);
